// Speed menu: a listbox opened from the trigger; arrows move the highlight
// (aria-activedescendant), Enter/Space choose, Escape or an outside click close.
export function bindSpeedMenu(player) {
    const { el, state, render, actions } = player;

    el.speedOptions.forEach((opt, i) => {
        opt.id = `${el.speedList.id || "speed"}-${i}`;
    });
    if (!el.speedList.id)
        el.speedList.id = `speed-${Math.random()
            .toString(36)
            .slice(2, 8)}`;
    el.speedOptions.forEach((opt, i) => {
        opt.id = `${el.speedList.id}-opt-${i}`;
    });

    function openMenu() {
        if (state.hasError) return;
        state.menuOpen = true;
        state.activeOption = el.speedOptions.findIndex(o => Number(o.dataset.rate) === state.playbackRate);
        render();
        el.speedList.focus();
        el.speedList.setAttribute("aria-activedescendant", (el.speedOptions[state.activeOption] || {}).id || "");
    }
    function closeMenu(returnFocus) {
        state.menuOpen = false;
        state.activeOption = -1;
        render();
        if (returnFocus) el.speedTrigger.focus();
    }
    function chooseOption(i) {
        const opt = el.speedOptions[i];
        if (!opt) return;
        actions.setPlaybackRate(Number(opt.dataset.rate));
        closeMenu(true);
    }

    el.speedTrigger.addEventListener("click", () => (state.menuOpen ? closeMenu(true) : openMenu()));
    el.speedOptions.forEach((opt, i) => opt.addEventListener("click", () => chooseOption(i)));
    el.speedList.addEventListener("keydown", e => {
        const last = el.speedOptions.length - 1;
        if (e.key === "Escape") {
            e.preventDefault();
            closeMenu(true);
        } else if (e.key === "ArrowDown") {
            e.preventDefault();
            state.activeOption = Math.min(last, state.activeOption + 1);
        } else if (e.key === "ArrowUp") {
            e.preventDefault();
            state.activeOption = Math.max(0, state.activeOption - 1);
        } else if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            chooseOption(state.activeOption);
            return;
        } else return;
        el.speedList.setAttribute("aria-activedescendant", (el.speedOptions[state.activeOption] || {}).id || "");
        render();
    });
    document.addEventListener("pointerdown", e => {
        if (state.menuOpen && !el.speedTrigger.contains(e.target) && !el.speedList.contains(e.target)) {
            closeMenu(false);
        }
    });
}
